import * as React from "react";
import { Typography } from "antd";
import { IReport7ApplicantPresentationModel } from "../../../../presenter/report/model/Report7ApplicantPresentationModel";
import { TTranslate } from "../../../../service/locale/TranslationService";
import Report7PreviewApplicant from "./Report7PreviewApplicant";
import { IReportingPeriodItem } from "../../../../model/report/ReportingPeriodItem";

const Report7Preview = ({
  report7Data,
  translate,
  selectedReportingPeriod
}: {
  report7Data: IReport7ApplicantPresentationModel[];
  translate: TTranslate;
  selectedReportingPeriod?: IReportingPeriodItem;
}) => {
  const renderApplicants = (
    report7Data: IReport7ApplicantPresentationModel[]
  ) => {
    let renderedApplicants: JSX.Element[] = [];

    report7Data.forEach((applicant: IReport7ApplicantPresentationModel) => {
      renderedApplicants.push(
        <Report7PreviewApplicant
          key={`pdf-applicant-${applicant.id}`}
          applicant={applicant}
          translate={translate}
        />
      );
    });
    return renderedApplicants;
  };

  return (
    <div>
      <Typography.Title style={{ fontSize: 25 }}>
        {translate("report7_preview.title")}
      </Typography.Title>
      <Typography.Title style={{ fontSize: 20, marginBottom: "1em" }}>
        {`${translate("report7_preview.name")}: ${
          selectedReportingPeriod?.name || ""
        }`}
      </Typography.Title>
      {renderApplicants(report7Data)}
    </div>
  );
};

export default Report7Preview;
